import { connect } from 'react-redux';
import { checkRoles } from 'modules/auth';
import Sync from '../components/Sync';

const mapDispatchToProps = {
  checkRoles,
};

export default connect(null, mapDispatchToProps)(Sync);
